
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#plots'), APPLICATION._PATH_PREFIX + 'property-database/plots', 'PropertyDatabase', 'plots')
      }

    },

    // plots scripts
    plots:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process links
        APPLICATION._APPLICATION.processLinks('#plots', 'PropertyDatabase', 'plots')

      }

    }

  }
